import 'vite/modulepreload-polyfill';
import React from 'react';
import ReactDOM from 'react-dom/client';
import LadderGame from '@/components/LadderGame/LadderGame';

const rootElement = document.getElementById('wooltari-ladder');
if (rootElement) {
  const gameName =
    rootElement.getAttribute('data-event-name') ||
    rootElement.getAttribute('data-game-name');
  const customerId = rootElement.getAttribute('data-customer-id');
  const email = rootElement.getAttribute('data-customer-email');
  const token = rootElement.getAttribute('data-token');
  const locale = rootElement.getAttribute('data-locale');
  const eventStartAt = rootElement.getAttribute('data-event-start');
  const eventEndsAt = rootElement.getAttribute('data-event-end');
  const loginUrl = rootElement.getAttribute('data-login-url');
  const loginToPlay = rootElement.getAttribute('data-login-to-play');
  const testToken = rootElement.getAttribute('data-test-token');

  // const articleId = "test"
  // const articleHandle = "test"

  const ladderPlayerImgs = rootElement.getAttribute('data-ladder-player-imgs');
  const ladderBg = rootElement.getAttribute('data-ladder-bg');
  const ladderPointerImg = rootElement.getAttribute('data-ladder-pointer-img');
  const ladderPrizeImg = rootElement.getAttribute('data-ladder-prize-img');

  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <LadderGame
        campaignName={gameName}
        customerId={customerId}
        email={email}
        language={locale}
        eventStartAt={eventStartAt}
        eventEndsAt={eventEndsAt}
        loginUrl={loginUrl}
        loginToPlay={loginToPlay}
        token={token}
        testToken={testToken}

        ladderPlayerImgs={ladderPlayerImgs.split(",")}
        ladderBg={ladderBg}
        ladderPointerImg={ladderPointerImg}
        ladderPrizeImg={ladderPrizeImg}
      />
    </React.StrictMode>,
  );
}